import React from 'react'
import BlogItem from '../BlogItem'
import './index.css'

const BlogList = ({blogs}) => (
  <ul className="blog-list">
    {blogs.map(blog => (
      <BlogItem key={blog.id} blog={blog} />
    ))}
  </ul>
)

export default BlogList
